// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cxcm4{position:relative;width:100%}.Cxcm4 .ql-toolbar{border:1px solid #282863;border-radius:4px 4px 0 0;padding:6px;display:flex;align-items:center;position:relative;flex-wrap:wrap}.Cxcm4 .ql-toolbar .ql-formats{text-align:start;margin-right:10px}.Cxcm4 .ql-toolbar .ql-formats:last-child{margin-right:0}.Cxcm4 .ql-toolbar button,.Cxcm4 .ql-toolbar .ql-picker-label{color:#282863}.Cxcm4 .ql-toolbar button .ql-stroke,.Cxcm4 .ql-toolbar .ql-picker-label .ql-stroke{stroke:#282863}.Cxcm4 .ql-toolbar button .ql-fill,.Cxcm4 .ql-toolbar .ql-picker-label .ql-fill{fill:#282863}.Cxcm4 .ql-toolbar button:hover,.Cxcm4 .ql-toolbar button.ql-active,.Cxcm4 .ql-toolbar .ql-picker-label:hover,.Cxcm4 .ql-toolbar .ql-picker-label.ql-active{color:#4520cc}.Cxcm4 .ql-toolbar button:hover .ql-stroke,.Cxcm4 .ql-toolbar button.ql-active .ql-stroke,.Cxcm4 .ql-toolbar .ql-picker-label:hover .ql-stroke,.Cxcm4 .ql-toolbar .ql-picker-label.ql-active .ql-stroke{stroke:#4520cc}.Cxcm4 .ql-toolbar button:hover .ql-fill,.Cxcm4 .ql-toolbar button.ql-active .ql-fill,.Cxcm4 .ql-toolbar .ql-picker-label:hover .ql-fill,.Cxcm4 .ql-toolbar .ql-picker-label.ql-active .ql-fill{fill:#4520cc}.Cxcm4 .ql-toolbar .ql-picker .ql-header{width:100px}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-label{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p2, 14px);line-height:var(--line-height-p2, 18px);letter-spacing:.02em;color:#282863}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-label .ql-stroke{stroke:#282863}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-label .ql-fill{fill:#282863}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-label:hover{color:#4520cc}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-label:hover .ql-stroke{stroke:#4520cc}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-label:hover .ql-fill{fill:#4520cc}.Cxcm4 .ql-toolbar .ql-picker.ql-expanded .ql-picker-label{color:#9393b1}.Cxcm4 .ql-toolbar .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#9393b1}.Cxcm4 .ql-toolbar .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#9393b1}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-options{background-color:#fcfcfd}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-item{color:#282863}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-item:hover{color:#4520cc}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-item:before{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 16px);line-height:var(--line-height-p1, 24px);letter-spacing:.015em}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-item[data-value="1"]:before{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-h5, 22px);line-height:var(--line-height-h5, 32px);letter-spacing:.01em}.Cxcm4 .ql-toolbar .ql-picker .ql-picker-item[data-value="2"]:before{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-h6, 20px);line-height:var(--line-height-h6, 35px);letter-spacing:.01em}.Cxcm4 .ql-container{border:1px solid #282863;border-radius:0 0 4px 4px}.Cxcm4 .ql-editor.ql-blank::before{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 16px);line-height:var(--line-height-p1, 24px);letter-spacing:.015em;opacity:.5}.Cxcm4 .ql-editor li,.Cxcm4 .ql-editor p{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 16px);line-height:var(--line-height-p1, 24px);letter-spacing:.015em}.Cxcm4 .ql-editor h1{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-h5, 22px);line-height:var(--line-height-h5, 32px);letter-spacing:.01em}.Cxcm4 .ql-editor h2{font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-h6, 20px);line-height:var(--line-height-h6, 35px);letter-spacing:.01em}.Cxcm4 .ql-editor a{color:#4520cc}.Cxcm4 .ql-editor strong{font-family:"Lufga-SemiBold";font-weight:400}.Cxcm4.hRZiM .ql-toolbar{border:1px solid #eb7272}.Cxcm4.hRZiM .ql-container{border:1px solid #eb7272}.Hf_mm{position:absolute;bottom:0;left:0;transform:translateY(100%)}.feUst{display:flex;align-items:center;margin-left:auto;width:auto !important;min-width:auto !important;max-width:none !important}.feUst>*{width:auto !important;min-width:auto !important;max-width:none !important}.feUst button{width:auto !important;min-width:auto !important;max-width:none !important}.Cxcm4 .ql-toolbar .toolbarActions{display:flex;align-items:center;margin-left:auto;width:auto !important;min-width:auto !important;max-width:none !important}.Cxcm4 .ql-toolbar .toolbarActions>*{width:auto !important;min-width:auto !important;max-width:none !important}.Cxcm4 .ql-toolbar .toolbarActions button{width:auto !important;min-width:auto !important;max-width:none !important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 48px)`,
	"fontSizeH2": `var(--font-size-h2, 40px)`,
	"fontSizeH3": `var(--font-size-h3, 33px)`,
	"fontSizeH4": `var(--font-size-h4, 28px)`,
	"fontSizeH5": `var(--font-size-h5, 22px)`,
	"fontSizeH6": `var(--font-size-h6, 20px)`,
	"fontSizeP1": `var(--font-size-p1, 16px)`,
	"fontSizeP2": `var(--font-size-p2, 14px)`,
	"fontSizeP3": `var(--font-size-p3, 12px)`,
	"lineHeightH1": `var(--line-height-h1, 64px)`,
	"lineHeightH2": `var(--line-height-h2, 56px)`,
	"lineHeightH3": `var(--line-height-h3, 40px)`,
	"lineHeightH4": `var(--line-height-h4, 40px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 35px)`,
	"lineHeightP1": `var(--line-height-p1, 24px)`,
	"lineHeightP2": `var(--line-height-p2, 18px)`,
	"lineHeightP3": `var(--line-height-p3, 16px)`,
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"root": `Cxcm4`,
	"error": `hRZiM`,
	"helperText": `Hf_mm`,
	"toolbarActions": `feUst`
};
export default ___CSS_LOADER_EXPORT___;
